import { render } from "./HotCard.vue?vue&type=template&id=454067f1&scoped=true"
import script from "./HotCard.vue?vue&type=script&lang=js"
export * from "./HotCard.vue?vue&type=script&lang=js"

import "./HotCard.vue?vue&type=style&index=0&id=454067f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454067f1"]])

export default __exports__